import { Box, Button, ButtonGroup } from "@mui/joy";
import DarkTypography from "../../common/DarkTypography";
import IconButtonCTA from "../../common/IconButtonCTA";
import { ChevronLeftIcon, ChevronRightIcon } from "../../../styles/StyledMUI";
import {
  statsPeriodLabelSx,
  statsPeriodNavButtonSx,
  statsYearSelectorButtonOutlinedSx,
  statsYearSelectorButtonSelectedSx,
} from "../../../styles/globalStyles";
import { GRANULARITY_OPTIONS } from "../statsPeriodHelpers";
import type { StatsPeriodState } from "../hooks/useStatsPeriod";

type StatsPeriodToolbarProps = {
  period: StatsPeriodState;
};

export default function StatsPeriodToolbar({ period }: StatsPeriodToolbarProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: { xs: 1.5, sm: 3 },
        mb: 2,
      }}
    >
      <ButtonGroup size="sm" sx={{ gap: 0.5, "--ButtonGroup-radius": "8px" }}>
        {GRANULARITY_OPTIONS.map((opt) => {
          const selected = period.granularity === opt.value;
          return (
            <Button
              key={opt.value}
              variant={selected ? "solid" : "outlined"}
              color="neutral"
              onClick={() => period.setGranularity(opt.value)}
              sx={selected ? statsYearSelectorButtonSelectedSx : statsYearSelectorButtonOutlinedSx}
            >
              {opt.label}
            </Button>
          );
        })}
      </ButtonGroup>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          minWidth: 0,
        }}
      >
        <IconButtonCTA
          aria-label="Période précédente"
          size="sm"
          onClick={period.goPrev}
          disabled={!period.canGoPrev}
          sx={statsPeriodNavButtonSx}
        >
          <ChevronLeftIcon />
        </IconButtonCTA>
        <DarkTypography level="title-lg" colorVariant="title" sx={statsPeriodLabelSx}>
          {period.label}
        </DarkTypography>
        <IconButtonCTA
          aria-label="Période suivante"
          size="sm"
          onClick={period.goNext}
          disabled={!period.canGoNext}
          sx={statsPeriodNavButtonSx}
        >
          <ChevronRightIcon />
        </IconButtonCTA>
      </Box>
    </Box>
  );
}
